import { APIFetch } from "../../lib/HttpClient";

/**
 * Meeting intelligence (spec v0.2 §8.1).
 *
 * The composite and divergence are computed server-side at read time from the
 * stored dimension scores against the contract's weight profile — so they are
 * read here, never recomputed on the client. The weights themselves are
 * deliberately never sent to us; only the profile name is.
 */

/** Seven dimensions, composite and summary for one meeting. */
export function getMeetingIntelligence(meetingId) {
  return APIFetch(`/intelligence/meeting/${meetingId}`)
    .then((resp) => (resp && resp.data ? resp.data : null))
    .catch((err) => {
      // A meeting that has not been scored yet is a normal state, not an error:
      // it is still being processed, or it never matched a MeetGeek recording.
      if (err && (err.status === 404 || err.statusCode === 404)) return null;
      return Promise.reject(err);
    });
}

/** Human vs AI averages and divergence for a contract, project or user. */
export function getScopeSummary(scope, scopeId) {
  return APIFetch(`/intelligence/summary/${scope}/${scopeId}`)
    .then((resp) => (resp && resp.data ? resp.data : null))
    .catch((err) => {
      if (err && (err.status === 404 || err.statusCode === 404)) return null;
      return Promise.reject(err);
    });
}

/**
 * HUMINT meeting score (HUMINT spec v1.0 §4.1): mean of the respondents' answer
 * to "how would you rate the value of this meeting?", plus the response count.
 * Independent of the AI side, so it is fetched separately.
 */
export function getMeetingHumanScore(meetingId) {
  return APIFetch(`/review/meeting/${meetingId}/summary`)
    .then((resp) => (resp && resp.data ? resp.data : null));
}
